/* import __COLOCATED_TEMPLATE__ from './navigation-container.hbs'; */
import Component from '@glimmer/component';

export default class NavigationContainer extends Component {}
